export const MIN_PASSWORD_LENGTH: number = 6;
export const MIN_LOGIN_LENGTH: number = 6;
export const MAX_LOGIN_LENGTH: number = 40;
export const MAX_PASSWORD_LENGTH: number = 40;
export const MASKED_PASSWORD: string = "----------";

export const OPERATOR_SETTING_PREFIX: string = "Operator_";